export const Base_Url = "https://apps.ng.kpmg.com/WhistleblowerAPI";
